import { NewRevision } from '~/api/version';

class VersionServiceClass {
  NewRevision = async (timeDimensionId: number, description: string): Promise<void> => {
    await NewRevision(timeDimensionId, description);
  };
}

export const VersionService = new VersionServiceClass();
